export const cyclesType = {
  WEEK_DAYS: "DIAS DE SEMANA",
  NUMBER_DAYS: "NUMERO DE DIAS",
  DATE: "FECHA",
  NO_CYCLE: "SIN CICLO",
};

export const programmingTypes = {
  PEDIDO: "PEDIDO",
  CUENTA: "CUENTA",
};

export const programmingTypeOptions = [
  { value: programmingTypes.PEDIDO, label: programmingTypes.PEDIDO },
  { value: programmingTypes.CUENTA, label: programmingTypes.CUENTA },
];
